module.exports = __webpack_public_path__ + "static/media/FilesExplorer.f11e2e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FilesExplorer.png
// module id = 7
// module chunks = 0